import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsActiveProperty,
  VentilationFilterInformationProperties,
  VentilationLockExternalProperties,
  VentilationSensorsActuatorSelftestProperties,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { CustomTranslationsService, STATE } from 'src/app/operational-data-common/translations';
import { NO_VALUE } from '../../../shared/pipes/dash/dash.pipe';

@Component({
  selector: 'app-service-layer-overlay',
  templateUrl: './service-layer-overlay.component.html',
  styleUrls: ['./service-layer-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceLayerOverlayComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  ventilationSensorsActuatorSelftest$: Observable<
    Feature<VentilationSensorsActuatorSelftestProperties, never>
  >;
  ventilationFilterInformation$: Observable<Feature<VentilationFilterInformationProperties, never>>;
  ventilationLockExternal$: Observable<Feature<VentilationLockExternalProperties, never>>;
  ventilationFanAssignmentSwitch$: Observable<Feature<IsActiveProperty, never>>;
  ventilationSwitchActivation$: Observable<Feature<IsActiveProperty, never>>;
  STATE = STATE;
  NO_VALUE = NO_VALUE;

  constructor(
    protected customTranslationsService: CustomTranslationsService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.ventilationSensorsActuatorSelftest$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsActuatorSelftest
    );

    this.ventilationFilterInformation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationFilterInformation
    );

    this.ventilationLockExternal$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationLockExternal
    );

    this.ventilationFanAssignmentSwitch$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationFanAssignmentSwitch
    );

    this.ventilationSwitchActivation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSwitchActivation
    );
  }
}
